import { Avatar } from '../../components/index.js'
import type { Chat } from '../../types/chat.js'

interface ConversationHeaderProps {
  chat: Chat
  displayName: string
}

export function ConversationHeader({ chat, displayName }: ConversationHeaderProps) {
  const memberCount = chat.members?.length ?? 0

  return (
    <div className="flex items-center gap-3 border-b border-(--color-border) bg-(--color-bg-primary) px-4 py-3">
      <Avatar name={displayName} size="md" />
      <div className="min-w-0 flex-1">
        <h3 className="truncate text-sm font-semibold text-(--color-text-primary)">
          {displayName}
        </h3>
        <p className="text-xs text-(--color-text-muted)">
          {chat.type === 'group'
            ? `Grupo · ${memberCount} membro${memberCount !== 1 ? 's' : ''}`
            : 'Conversa direta'}
        </p>
      </div>
    </div>
  )
}
